import React from "react";

import   Success from "../assets/img/check-mark.svg"; // Create this CSS file
import   Failure from "../assets/img/failure.svg"; // Create this CSS file
import   Loading from "../assets/img/spinner-of-dots.svg"; // Create this CSS file


import   "../assets/css/confirmbuy.css";

export default function ConfirmBuyModal({ open, onClose, onConfirm, pkg, status,setStatusText,purchaseType ,priceBreakdown}) {
  
  // Show modal if it's explicitly open OR if there is a status to show
  if (!open && (!status || !status.visible)) return null;

  // Function to handle OK click for persistent status messages
  // const handleStatusOk = () => {
  //   if (status && status.setStatusText) {
  //     status.setStatusText(prev => ({ ...prev, visible: false })); // hide status
  //   }
  // };
  // 🔥 FIX 1 — BACKDROP CLICK CLOSE
  const closeByBackdrop = (e) => {
    if (e.target.classList.contains("modal-backdrop")) {
      handleCloseAll();
    }
  };

  // 🔥 Common close handler for X, OK, Cancel
  const handleCloseAll = () => {
    if (setStatusText) {
      setStatusText({ visible: false });
    }
    if (onClose) onClose();
  };

  // OK Button handler for success/error messages
  const handleStatusOk = () => {
    if (setStatusText) {
      setStatusText(prev => ({ ...prev, visible: false }));
    }
    if (onClose) onClose(); 
  };

  return (
   <div className="modal-backdrop" onClick={closeByBackdrop}>
      <div className="modal-box">
            <span className="top-line spn-bg"></span>
                  <span className="right-line spn-bg"></span>
                  <span className="bottom-line spn-bg"></span>
                  <span className="left-line spn-bg"></span>


        <button className="close-btn" onClick={handleCloseAll}>✕</button>

        {status && status.visible ? (
          <div className="cjm-status-container">

            {status.type === "loading" && <div className="cjm-status-icon spin"><img src={Loading} className="Failure-img" /></div>}
            {status.type === "success" && <div className="cjm-status-icon success"> <img src={Success} className="Failure-img" /></div>}
            {status.type === "error" && <div className="cjm-status-icon error">
               <img src={Failure} className="Failure-img" />
              
              </div>}
 

     <h3 className="cjm-status-title">{status.title}</h3>
            <p className="cjm-status-message">{status.message}</p>



            {/* {status.type !== "loading" && status.persist && (
              <button className="status-ok-btn" onClick={handleStatusOk}>
                OK
              </button>
            )} */}

            {status.type === "confirm" && status.onConfirm && (
              <div className="confirm-row">
                <button
                  className="confirm-btn"
                  onClick={() => {
                    status.onConfirm();
                    handleCloseAll();
                  }}
                >
                  Confirm
                </button>

                <button className="cancel-btn" onClick={handleCloseAll}>
                  Cancel
                </button>
              </div>
            )}
          </div>
        ) : (
          <>
            {pkg ? (
              <>
                {/* <h3 className="title">Confirm Package Purchase</h3>
                <p className="subtitle">Please check your package details before approving payment.</p>

                <div className="package-info">
                  <h2 className="pkg-price">${pkg.price}</h2>
                  <h4 className="pkg-name">{pkg.name}</h4>
                </div> */}

                <h3 className="title">
  {purchaseType === "nft"
    ? "Confirm NFT Purchase"
    : "Confirm Package Purchase"}
</h3>

<p className="subtitle">
  {purchaseType === "nft"
    ? "Please check your NFT details before approving payment."
    : "Please check your package details before approving payment."}
</p>


<div className="package-info">
  <h2 className="pkg-price">
    ${pkg?.price}
  </h2>

  {/* <h4 className="pkg-name">
    {purchaseType === "nft"
      ? `NFT #${pkg?.tokenId}`
      : pkg?.name}
  </h4> */}

  <h4 className="pkg-name">
  {pkg?.name}
</h4>

{purchaseType === "nft" && priceBreakdown && (
  <div className="alert alert-warning mt-3">

    {priceBreakdown.isResale ? (
      <>
        <p><b>NFT Price:</b> {priceBreakdown.base} USDT</p>
        <p><b>Resale Fee (10%):</b> {priceBreakdown.extra} USDT</p>

        <hr />

        <p><b>Total Payable:</b> {priceBreakdown.total} USDT</p>

        <p style={{ color: "red", marginTop: "8px" }}>
          ⚠️ 10% extra amount will be deducted from your wallet.
        </p>
      </>
    ) : (
      <p><b>Price:</b> {priceBreakdown.base} USDT</p>
    )}

  </div>
)}

</div>

                <button className="confirm-approve-btn" onClick={onConfirm}>
                  Confirm & Approve
                </button>
              </>
            ) : (
              <p className="no-data">Package data not available.</p>
            )}
          </>
        )}
      </div>
    </div>
  );
}
